import {
  isAddendumBackPayItem,
  isBackPayItem,
} from "../../../Payroll/helper-payroll/constants/payrollConstants";

const fieldExclusionRules = [
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Basic Pay" && payItem === "General Payroll",
    fields: ({ contributions, deductions }) => [
      "employee",
      "peraAda",
      "overpaymentBasic",
      "overpaymentPeraAda",
      "earnedBasic",
      "earnedPeraAda",
      "tax",
      ...contributions,
      ...deductions,
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Basic Pay" &&
      jobType !== "Job Order" &&
      payItem === "Addendum Payroll",
    fields: ({ contributions, deductions }) => [
      "employee",
      "peraAda",
      "daysToBeDeducted",
      "halfDaysToBeDeducted",
      "minutesToBeDeducted",
      "gsisInsuredDays",
      "deductionDueToLeavesTardy",
      "deductionPeraAda",
      "overpaymentBasic",
      "overpaymentPeraAda",
      "earnedBasic",
      "earnedPeraAda",
      "tax",
      ...contributions,
      ...deductions,
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Basic Pay" && isAddendumBackPayItem(payItem),
    fields: ({ contributions, deductions }) => [
      "employee",
      "daysInAMonth",
      "gsisInsuredDays",
      "daysToBeDeducted",
      "halfDaysToBeDeducted",
      "minutesToBeDeducted",
      "peraAda",
      "deductionDueToLeavesTardy",
      "deductionPeraAda",
      "overpaymentBasic",
      "overpaymentPeraAda",
      "earnedBasic",
      "earnedPeraAda",
      "tax",
      ...contributions,
      ...deductions,
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Augmentation Pay" &&
      (payItem === "General Payroll" || payItem === "Newly-Hired"),
    fields: ({ deductions }) => [
      "employee",
      "assignedArea",
      "dutyForCiaMciaBinoc",
      "absencesPresent",
      "latesUTMinsPresent",
      "noOfDuties",
      "absencesAugmentation",
      "latesUTMinsAirport",
      "payCode",
      "totalDaysDuty",
      "proratedApRate",
      "absencesLeavesCurrAss",
      "latesUTMinsCurrent",
      "earnedCurrAssignment",
      "airportAugRate",
      "earnedAirportAug",
      "absencesLeavesAirportAss",
      "latesUTMinsAirportAug",
      "earnedAirportDuties",
      "excessAirportDuty",
      "totalEarned",
      "overpayment",
      "flagRaising",
      "netEarned",
      "tax",
      ...deductions,
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Basic Pay" &&
      jobType === "Job Order" &&
      isBackPayItem(payItem),
    fields: ({ deductions }) => [
      "employee",
      "year",
      "month",
      "basicRateForBackPay",
      "daysToBeDeducted",
      "minutesToBeDeducted",
      "absencesDays",
      "absencesMins",
      "overpayment",
      "flagRaising",
      "earnedForThePeriod",
      "threePercent",
      "twoPercent",
      "fivePercent",
      "tenPercent",
      "totalTax",
      ...deductions,
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem }) =>
      payrollType === "Augmentation Pay" && isBackPayItem(payItem),
    fields: ({ deductions }) => [
      "employee",
      "year",
      "month",
      "assignedArea",
      "dutyForCiaMciaBinoc",
      "absPresentAss_1",
      "lateUTperMinutePresentAss_1",
      "noOfDuties",
      "absAirportAss_1",
      "lateUTperMinuteAirportAss_1",
      "apRateForBackPay",
      "totalDaysDuty",
      "proratedApRate",
      "absPresentAss_2",
      "lateUTperMinutePresentAss_2",
      "earnedCurrentAssignment",
      "airportAugmentationRate",
      "amountEarnedAirportAugmentation",
      "absAirportAss_2",
      "lateUTperMinuteAirportAss_2",
      "earnedAirportDuties",
      "excessAirportDuties",
      "overpayment",
      "flagRaising",
      "netEarned",
      "tax",
      ...deductions,
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Individual Payroll" &&
      ["Initial Salary", "Last Salary"].includes(payItem) &&
      jobType !== "Job Order",
    fields: ({ contributions }) => [
      "employee",
      "gross",
      "peraAda",
      "inService",
      "proratedRate",
      "proratedPera",
      "minsDeduction",
      "minsBasic",
      "minsPera",
      "daysForGsis",
      "basicEarned",
      "peraAdaEarned",
      "totalforBasicPera",
      "tax",
      ...contributions,
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Individual Payroll" &&
      jobType === "Job Order" &&
      payItem === "Initial Salary",
    fields: [
      "employee",
      "dutyForCiaMciaBinoc",
      "noOfDaysPresent",
      "proratedRate",
      "minutesToBeDeducted",
      "absencesMins",
      "earned",
      "twentyPercent",
      "gratuityPay",
      "totalEarned",
      "threePercent",
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Individual Payroll" &&
      jobType === "Job Order" &&
      payItem === "Last Salary",
    fields: [
      "employee",
      "dutyForCiaMciaBinoc",
      "noOfDaysPresent",
      "proratedRate",
      "minutesToBeDeducted",
      "absMins",
      "earned",
      "twentyPercent",
      "gratuityPay",
      "totalEarned",
      "threePercent",
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Individual Payroll" &&
      ["Initial Salary(AP)", "Last Salary(AP)"].includes(payItem),
    fields: [
      "employee",
      "assignedArea",
      "dutyForCiaMciaBinoc",
      "payCode",
      "overpayment",
      "flagRaising",
      "daysEarned",
      "noOfLatesIncurred",
      "latesUtDeduction",
      "earnedForThePeriod",
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Individual Payroll" && payItem === "Initial RATA",
    fields: [
      "employee",
      "rataAllowance",
      "actualWorkPerformance",
      "actualRataForAMonth",
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Individual Payroll" &&
      payItem === "Salary Differential (Basic)",
    fields: [
      "employee",
      "totalAmtEarned",
      "gsis",
      "philhealth",
      "tax",
      "myDiff",
      "yeDiff",
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem, jobType }) =>
      payrollType === "Basic Pay" &&
      jobType === "Job Order" &&
      payItem === "Salary",
    fields: ({ deductions }) => [
      "employee",
      "daysToBeDeducted",
      "minutesToBeDeducted",
      "absencesDays",
      "absencesMins",
      "overpayment",
      "flagRaising",
      "earnedForThePeriod",
      "threePercent",
      "twoPercent",
      "fivePercent",
      "tenPercent",
      "totalTax",
      ...deductions,
      "netAmount",
    ],
  },
  {
    condition: ({ payrollType, payItem }) =>
      payrollType === "Special Payroll" && payItem !== "20% Monthly Premium",
    fields: ({ incentives }) => ["employee", ...incentives, "netAmount"],
  },
  {
    condition: ({ payrollType, payItem }) =>
      payrollType === "Special Payroll" && payItem === "20% Monthly Premium",

    fields: [
      "employee",
      "earnedForThePeriodFrom",
      "earnedForThePeriodTo",
      "totalEarned",
      "twentyPercentEarned",
      "threePercent",
      "netAmount",
    ],
  },
];

export const _getExcludedFields = ({
  payrollType,
  payItem,
  jobType,
  contributions = [],
  deductions = [],
  incentives = [],
}) => {
  return fieldExclusionRules
    .filter((rule) =>
      rule.condition({
        payrollType,
        payItem,
        jobType,
        contributions,
        deductions,
        incentives,
      })
    )
    .flatMap((rule) =>
      typeof rule.fields === "function"
        ? rule.fields({ contributions, deductions, incentives })
        : rule.fields
    );
};
